module.exports = __webpack_public_path__ + "static/media/score-one.04b7d7e6.svg";